import { createReducer, on } from '@ngrx/store';
import { IPermissionsState, initialPermissionsState } from './permissions.state';
import { LoggedUserPermissionsLoaded, PermissionsLoaded, UserPermissionsLoaded } from './permissions.action';


export const initialState: IPermissionsState = {
  userPermissions: [],
  permissions: [],
  loggedUserPermissions: []
};

const setLoggedUserPermissions = (state: IPermissionsState, { loggedUserPermissions }: { loggedUserPermissions: IPermissionsState['loggedUserPermissions'] }) => ({
  ...state,
  loggedUserPermissions: [ ...loggedUserPermissions ]
});

const setUserPermissions = (state: IPermissionsState, { userPermissions }: { userPermissions: IPermissionsState['userPermissions'] }) => ({
  ...state,
  userPermissions: [ ...userPermissions ]
});

const setPermissions = (state: IPermissionsState, { permissions }: { permissions: IPermissionsState['permissions'] }) => ({
  ...state,
  permissions: [ ...permissions ]
});

const _loggedUserPermissionsReducer = createReducer<IPermissionsState>(
  initialPermissionsState,
  on(LoggedUserPermissionsLoaded, setLoggedUserPermissions)
);

const _userPermissionsReducer = createReducer<IPermissionsState>(
  initialPermissionsState,
  on(UserPermissionsLoaded, setUserPermissions)
);

const _permissionsReducer = createReducer<IPermissionsState>(
  initialPermissionsState,
  on(PermissionsLoaded, setPermissions)
);

export function loggedUserPermissionsReducer(state: IPermissionsState, action): IPermissionsState {
  return _loggedUserPermissionsReducer(state, action);
}

export function userPermissionsReducer(state: IPermissionsState, action): IPermissionsState {
  return _userPermissionsReducer(state, action);
}

export function permissionsReducer(state: IPermissionsState, action): IPermissionsState {
  return _permissionsReducer(state, action);
}
